const replaceValuesInLabel = (
  label: string,
  replacementArray: Array<string | number>
) => {
  if (!label?.includes('{0}')) return label;

  let newLabel = label;

  replacementArray.forEach((value, index) => {
    newLabel = newLabel.replace(`{${index}}`, value.toString());
  });

  return newLabel;
};

export default replaceValuesInLabel;
